// Async Thunk for generating the application
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAxiosClient } from "../../../services/HttpsService";
import { AgentDetails } from "./chat-interfaces";
import {
  AgentMetadata,
  AddAgentInputData,
  ApiResponse,
} from "./chat-interfaces";
import { fetchApplications } from "../applications/applications-async-calls";
// import { UserService } from "@/services/UserService";
import { UserService } from "../../UserService";

export const generateApplication = createAsyncThunk(
  "chat/generateApplication",
  async (
    {
      userInput,
      selectedApps,
      requestId,
      sessionId,
      environment,
    }: {
      userInput: string;
      selectedApps: { uuid: string; name: string }[];
      requestId: string;
      sessionId?: string;
      environment?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await getAxiosClient().post(
        `${process.env.REACT_APP_JSON_GENERATOR_URL}/generate_application/url`,
        {
          user_input: userInput,
          request_id: requestId,
          session_id: sessionId, // Include session ID in request
          environment: process.env.REACT_APP_ENVIRONMENT,
        }
      );

      return response.data as ApiResponse;
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunk for importing the application
export const importApplication = createAsyncThunk(
  "chat/importApplication",
  async (file: string, { dispatch, rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("fileUrl", file);
      formData.append("userName", UserService.getUserEmail());
      await getAxiosClient().post(
        "/import-export/import/application",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(fetchApplications()); // Refresh application list
      return true;
    } catch (error: any) {
      return rejectWithValue("Failed to import application.");
    }
  }
);

// Async Thunk for creating an agent
export const createAgent = createAsyncThunk(
  "chat/createAgent",
  async (agentDetails: AgentDetails, { rejectWithValue }) => {
    try {
      const agentPayload = {
        processUuid: agentDetails.processCd,
        agentId: agentDetails.agentId,
        agentName: agentDetails.agentName,
        email: "demo.user6@eizen.ai", // Consider making this dynamic
      };
      const eizenXUrl = `${process.env.REACT_APP_BACKEND_API}/main/start?processId=7caa1481-a59b-4480-b610-3ab10b3721c0`;
      const response = await getAxiosClient().post(eizenXUrl, agentPayload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue("Failed to create agent.");
    }
  }
);

export const addAgent = createAsyncThunk(
  "chat/addAgent",
  async (inputData: AddAgentInputData, { rejectWithValue }) => {
    try {
      const agentPayload = {
        inputData: inputData,
      };

      const addAgentUrl = `${process.env.REACT_APP_BACKEND_API}/main/webapi/add-agent`;
      const response = await getAxiosClient().post(addAgentUrl, agentPayload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue("Failed to add agent.");
    }
  }
);
